import Text from '@ulta/core/components/Text/Text';

export default Text;
